import { getStorageItem, setStorageItem } from 'utils/ui/storage';

/**
 * Stable per-tab identifier for VOIP master election (AVS-4302).
 *
 * Backed by sessionStorage (NOT the in-memory `localAveTabId`) so it survives a
 * page reload but stays unique per browser tab. This is the key the elected VOIP
 * master is compared against: a reload must keep the same tab as master, while a
 * second tab of the same dealer must resolve to a distinct id (and therefore a
 * standby).
 *
 * Mirrors `bandwidthManager.getTabId()`.
 */
export const getVoipTabId = (): string => {
  const existing = getStorageItem('sessionStorage', 'voip-tab-id');
  if (existing) return existing;

  const id = `voip-${crypto.randomUUID()}`;
  setStorageItem('sessionStorage', 'voip-tab-id', id);
  return id;
};
